// Wording and option lists of the Medicare Annual Wellness Visit screener.
export const ANNUAL_WELLNESS_GROUPS = {
  depression: "Depression Screening",
  fallRisk: "Fall Risk Screening",
  hearing: "Hearing Impairment Screening",
  medicalProblems: "Current Medical Problems",
  pastHistory: "Past Medical History",
  homeSafety: "Home Safety Checklist",
  socialHistory: "Social History",
  healthMaintenance: "Health Maintenance",
  advanceDirective: "Advance Directive",
} as const;

export const ANNUAL_WELLNESS_HIDDEN_QUESTIONS = [
  "Patient/Authorized signature",
  "Authorized person name",
  "Authorized person relationship",
  "Provider signature",
];

export const SPECIFY_DETAILS_PLACEHOLDER = "Specify Details...";

export const VISIT_TYPE_OPTIONS = [
  "Welcome (G0402)",
  "Initial (G0438)",
  "Subsequent (G0439)",
];
export const DEPRESSION_OPTIONS = [
  "No",
  "Several days",
  "More than half the days",
  "Nearly every day",
];
export const FALL_CIRCUMSTANCE_OPTIONS = [
  "Tripped over something",
  "Injured",
  "Lightheadedness or palpitations prior to fall",
  "Loss of consciousness",
  "Needed to see a doctor",
  "Able to get up on own",
];
export const HEARING_OPTIONS = ["No", "Yes", "Sometimes"];
export const LIVING_SITUATION_OPTIONS = [
  "Apartment/Condo",
  "Assisted living",
  "House",
];
export const HEATING_OPTIONS = [
  "Oil heat",
  "Gas heat",
  "Electric heat/AC",
  "Fireplace",
  "Fans",
  "Open windows",
];
export const COOKING_APPLIANCE_OPTIONS = [
  "Gas oven/stove",
  "Electric oven/stove",
  "Microwave",
  "Toaster",
  "Crockpot",
  "Others",
];
export const MEDICATION_TRACKING_OPTIONS = [
  "No method used",
  "Medicines lined up",
  "Pre-poured or preplaced pills in a pillbox",
  "Bubble packs of meds",
  "Others",
];
export const MEDICATION_ADMINISTERED_BY_OPTIONS = [
  "Self",
  "Family member",
  "Care giver",
];
export const ASSISTIVE_DEVICE_OPTIONS = [
  "Comfort-height toilet",
  "Portable commode",
  "Stair lift",
  "Hoyer lift",
  "Hospital bed",
  "Chair lift",
  "Remote patient monitoring",
  "Grab bars",
  "O2",
  "Other / Suppliers",
];

export const HEARING_QUESTIONS = [
  "Do you wear hearing aids?",
  "Does a hearing problem cause you to feel embarrassed when meeting new people?",
  "Does a hearing problem cause you to feel frustrated when talking to members of your family?",
  "Do you have difficulty hearing when someone speaks in a whisper?",
  "Do you feel handicapped by a hearing problem?",
  "Does hearing problems cause you difficulty when visiting friends, relatives or neighbors?",
  "Does hearing problems cause you to attend religious services less often than you would like?",
  "Does a hearing problem cause you to have arguments with family?",
  "Does a hearing problem cause you difficulty when listening to TV or radio?",
  "Do you feel any difficulty with your hearing limits or hampers your personal or social life?",
  "Does a hearing problem cause you difficulty when in a restaurant with relatives or friends?",
];

export const ROUTINE_TASKS = [
  "Feeding yourself",
  "Getting from bed to chair",
  "Getting to the toilet",
  "Getting dressed",
  "Bathing or showering",
  "Walking across the room",
  "Using the telephone",
  "Taking your medicines",
  "Preparing meals",
  "Managing money/expenses/bills",
  "Moderate strenuous housework",
  "Shopping for personal items",
];

export const HEALTH_MAINTENANCE_ITEMS = [
  "HepB (shot)",
  "Flu vaccine (shot)",
  "Pneumonia vaccine (shot)",
  "Tetanus Diphtheria (shot)",
  "Zostavax (shot)",
  "Abdominal Aortic Aneurysm Screen",
  "Bone Density Scan",
  "Diabetes Self Management Training",
  "Colonoscopy",
  "Echocardiogram",
  "Eye glaucoma scan",
  "Glucose",
  "Hearing Exam",
  "Hemocult",
  "Mammogram",
  "Nutritional Therapy",
  "Pap smear",
  "Pelvic Exam",
  "Prostate Exam",
  "PSA Test",
  "Rectal Exam",
  "Smoking cessation",
];
